<script setup lang="ts">
import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import debounce from "lodash-es/debounce";

import type {
  LanguageType,
  LanguagePayloadType,
} from "@/common/types/language";

import { baseInput } from "@/common/components";

const { t } = useI18n();

const emit = defineEmits(["update:data", "salve:data"]);

const props = defineProps<{
  data?: LanguageType | null;
  isPatch?: boolean;
}>();

const DEFAULT_DATA = {
  name: "",
};

const payload = ref<LanguagePayloadType>({ ...DEFAULT_DATA });

function update(key: keyof typeof payload.value) {
  if (props.isPatch) {
    emit("update:data", { [key]: payload.value[key] });
    return;
  }

  emit("update:data", payload.value);
}

function resumeData() {
  if (!props.data) return;

  const { name } = props.data;

  payload.value = {
    ...payload.value,
    name,
  };
}

const debouceUpdate = debounce(update, 300);

watchEffect(() => {
  resumeData();
});
</script>

<template>
  <section class="form-language">
    <base-input
      v-model="payload.name"
      :value="payload.name"
      :placeholder="t('language.placeholders.name')"
      required
      @update:modelValue="debouceUpdate('name')"
    >
      <template #label> {{ t("language.labels.name") }} * </template>
    </base-input>
  </section>
</template>

<style lang="scss" scoped>
.form-language {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;
}
</style>
